import { useEffect, useState } from 'react';
import useCartQuantity from './hooks/useCartQuantity';
import { useTranslation } from 'react-i18next';
import { WinePackageWidgetModel } from '../../../models/WinePackageWidgetModel';
import { useColorContext } from 'shared-widget-components/src/providers/ColorsProvider';

interface CartComponentProps {
  winePackage: WinePackageWidgetModel;
}

// csomagkártyákon megjelenő kosár
export const CartComponent = ({ winePackage }: CartComponentProps) => {
  const { buttonColor, buttonTextColor } = useColorContext();
  const { t } = useTranslation();
  const { increment, decrement, cartQuantity } = useCartQuantity({ winePackage });
  const [isAdmin, setIsAdmin] = useState(false);

  // ha a kosár mennyisége megegyezik a minimum mennyiséggel, akkor a minusz gomb legyen disabled
  const isMinusButtonDisabled = cartQuantity === winePackage.minimumCartQuantity;
  // ha a kosár mennyisége megegyezik a maximum mennyiséggel, akkor a plusz gomb legyen disabled
  const isPlusButtonDisabled = cartQuantity === winePackage.maximumCartQuantity || cartQuantity === winePackage.availableQuantity;

  // determine if the user is on the admin page
  useEffect(() => {
    //@ts-ignore
    setIsAdmin(window.isAdminPage);
  }, []);

  const addToCart = () => {
    //@ts-ignore
    if (isAdmin) return;
    //@ts-ignore
    if (!cartHandler) return;
    //@ts-ignore
    cartHandler && cartHandler.addOrUpdateCart(winePackage.productVariantId);
  };

  return (
    <div className={`flex w-full min-[350px]:h-[35px] md:h-[40px] group ${winePackage.showEurPrice ? 'md:mt-[4px] lg:mt-0' : 'min-[350px]:mt-0 md:mt-0 lg:mt-[12px]'}`}>
      <div className='flex w-2/5 justify-between items-center rounded-l-md border border-r-0 border-slate-400 duration-200 transition-opacity overflow-hidden'>
        <button
          type='button'
          className={`${
            isMinusButtonDisabled ? ' cursor-not-allowed' : 'cursor-pointer'
          } min-[350px]:w-[35px] min-[350px]:h-[35px] md:h-[40px] md:w-[40px] pb-[4px] flex justify-center text-[24px] font-semibold items-center rounded-md outline-none focus:outline-none active:outline-none bg-white hover:text-opacity-80 duration-200 transition-opacity`}
          onClick={decrement}
          disabled={isMinusButtonDisabled}
        >
          -
        </button>
        <p className='font-body font-medium flex justify-center items-center'>{cartQuantity}</p>
        <button
          type='button'
          className={`${
            isPlusButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } min-[350px]:w-[35px] min-[350px]:h-[35px] md:h-[40px] md:w-[40px] pb-[4px] text-[24px] font-semibold flex justify-center items-center rounded-l-md outline-none focus:outline-none active:outline-none bg-white hover:text-opacity-80 duration-200 transition-opacity`}
          onClick={increment}
          style={{ color: buttonColor }}
          disabled={isPlusButtonDisabled}
        >
          +
        </button>
        <input
          hidden
          type='number'
          data-quantity-id={winePackage.productVariantId}
          data-ga-name={winePackage.title}
          data-ga-variant={winePackage.content.length}
          data-ga-category='Csomagok'
          data-ga-price={winePackage.discount ? winePackage.currentPrice : winePackage.basePrice}
          //TODO data-ga-brand csere
          data-ga-brand={winePackage.title}
          value={cartQuantity}
        />
      </div>
      <button
        type='button'
        className='w-3/5 font-bold rounded-r hover:opacity-80 duration-200 transition-opacity outline-none focus:border-none focus:outline-none'
        onClick={addToCart}
        style={{ backgroundColor: buttonColor, color: buttonTextColor }}
      >
        {t('winePackageWidget.cart')}
      </button>
    </div>
  );
};
